import uly from "ulysses/base";
import $ from "jquery";
import ko from "knockout";

"use strict";

function extract_id(item_or_id) {
    if (!item_or_id)
        return null;
    if (item_or_id.unique_id) {
        return item_or_id.unique_id;
    } else {
        return item_or_id;
    }
}
function extract_item(item_or_id) {
    if (!item_or_id)
        return null;
    if (item_or_id.unique_id) {
        return item_or_id;
    }
    return null;
}

function SearchSelection(current_page_observable) {
    var current_page = current_page_observable;

    var self = this;
    $.extend(this, {
        selected_ids: ko.observableArray([]),
        selection: ko.observableArray([]),
        all_selected: ko.observable(false),
        push: function push(item_or_id) {
            if (this.all_selected())
                return;

            var item_id = extract_id(item_or_id);
            if (!item_id)
                return;

            if (this.selected_ids.indexOf(item_id) >= 0) {
                return;
            }
            this.selected_ids.push(item_id);
            var item = extract_item(item_or_id);
            if (item != null) {
                this.selection.push(item);
            }
            //now recheck if all page is currently selected
            var items = ko.unwrap(current_page);
            var all_selected = true;
            if (items) {
                $.each(items, function(idx, item) {
                    if (ko.unwrap(item.bulk_actions) && ko.unwrap(item.bulk_actions).length) {
                        if (!self.is_selected(item))
                            all_selected = false;
                    }
                });
                this.all_page_selected(all_selected);
            }
        },
        remove: function remove(item_or_id) {
            if (this.all_selected())
                return;

            var item_id = extract_id(item_or_id);
            if (!item_id)
                return;
            this.all_page_selected(false);
            this.selected_ids.remove(function(candidate) {return candidate === item_id; });
            this.selection.remove(function(candidate) { return candidate.unique_id === item_id; });
        },
        is_selected: function is_selected(item_or_id) {
            if (this.all_selected())
                return true;
            var item_id = extract_id(item_or_id);
            return this.selected_ids.indexOf(item_id) >= 0;
        },
        clear: function clear() {
            this.all_selected(false);
            this.all_page_selected(false);
            this.selected_ids([]);
            this.selection([]);
        },
        all_page_selected: ko.observable(false),
        select_all_on_page: function select_all_on_page(results) {
            var self = this;
            //first baby step: select whole page
            if (!current_page) {
                current_page = results;
                if (ko.isObservable(current_page)) {
                    current_page.subscribe(function() {
                        self.all_page_selected(false);
                    });
                }
            }
            self.all_page_selected(true);
            var items = ko.unwrap(results);
            $.each(items, function(idx, item) {
                if (ko.unwrap(item.bulk_actions) && ko.unwrap(item.bulk_actions).length) {
                    self.push(item);
                }
            });
        },
        select_all: function select_all(results, query) {
            //force all page selected to get fake list of actions
            this.select_all_on_page(results);
            //mark all selected
            this.all_selected(query || true);
        },
        length: ko.pureComputed(function() {
            return this.selection().length;
        }),
        full_selection: ko.pureComputed(function() {
            if (!self.all_selected())
                return self.selection();
            //fetch query parameters for server-side processing
            var query = self.all_selected();
            return query;
        }),
        items_selected: ko.pureComputed(function() {
            return _('search_x_items_selected', '{0} items selected.').format(ko.unwrap(self.length));
        })
    });
    this.length = ko.pureComputed(function() {
        return self.selection().length;
    });
    this.bulk_actions = ko.pureComputed(function() {
        var result = [];
        var names = [];
        var actions = {};
        $.each(self.selection(), function(idx, resource) {
            var bulk_actions = ko.unwrap(resource.bulk_actions) || [];
            $.each(bulk_actions, function(idx, action) {
                if (actions[action.name]) {
                    actions[action.name].count += 1;
                } else {
                    actions[action.name] = { "action": action, count: 1};
                    names.push(action.name);
                }
            });
        });
        var len = self.length();
        console.log("len:", len, "actions:", actions);
        $.each(names, function(idx, name) {
            if (actions[name].count === len) {
                result.push(actions[name].action);
            }
        });
        return result;
    });

}

export default SearchSelection;
